import Axios from 'configs/Axios';
import { UserProfileResponse, UserUpgradeResponse } from 'types/authentication';
import {
  UserData,
  UserFormValues,
  UserProfileRegisterUpdateFormValues,
  UserUpgradeApi,
} from 'types/users';

export const getConfig = (token: string) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const register = (user: UserFormValues, token?: string) =>
  Axios.post<UserProfileResponse>(
    `/register`,
    user,
    token ? getConfig(token) : undefined,
  );

export const upgradeUser = (userUpgrade: UserUpgradeApi) =>
  Axios.post<UserUpgradeResponse>(`/upgrade`, userUpgrade);

export const loginUser = () => Axios.get<UserProfileResponse>('/login');

/**
 * This is called before firebase logout as a request from the BE
 * to be able to generate some reports needed.
 */
export const logoutUser = () => Axios.get('/logout');

export const getUserProfile = () =>
  Axios.get<UserProfileResponse>('/userProfile');

type UserServerUpdate = Omit<UserFormValues, 'birthdate'> & {
  birthDate: string;
};

export const updateUserProfile = (data: UserProfileRegisterUpdateFormValues) =>
  Axios.put<UserServerUpdate>(`/userProfile`, data);

export const deleteUserProfile = () => Axios.delete(`/userProfile`);

export const updateUserActiveSite = (siteId: string) =>
  Axios.put<UserData>(`/userProfile/site/${siteId}`);

export const ping = () => Axios.get('/ping');

export const changeMainMember = (newMainMemberId: string) =>
  Axios.put(`/userProfile/changeMainMember/${newMainMemberId}`);
